module.exports = __webpack_public_path__ + "static/media/Rectangle9.347d394a.svg";